import { Controller } from "@hotwired/stimulus";

// Dispatches 'visibility:enter' when element enters viewport.
// Use with data-action to trigger any controller method on visibility.
//
// Example - infinite scroll:
//   %button{ data: { controller: 'visibility',
//                    action: 'visibility:enter->search#loadMore click->search#loadMore',
//                    visibility_root_margin_value: '300px' } }
//
// Example - lazy load image:
//   %img{ data: { controller: 'visibility',
//                 action: 'visibility:enter->lazy-image#load',
//                 visibility_once_value: true } }
//
export default class extends Controller {
  static values = {
    rootMargin: { type: String, default: "200px" },
    threshold: { type: Number, default: 0 },
    once: { type: Boolean, default: true },
  };

  connect() {
    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          this.dispatch("enter", { bubbles: true });
          if (this.onceValue) {
            this.observer.disconnect();
          }
        }
      },
      {
        rootMargin: this.rootMarginValue,
        threshold: this.thresholdValue,
      },
    );
    this.observer.observe(this.element);
  }

  disconnect() {
    this.observer?.disconnect();
  }

  // Allow manual re-observation (e.g., after content update)
  reobserve() {
    this.observer?.observe(this.element);
  }
}
